import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Constant } from "../../../core/constant";
import { NzModalRef } from "ng-zorro-antd/modal";
import { ModalComponent } from "../modal.component";
import { EventManager } from "../../../core";

@Component({
  selector: "app-confirm-popup",
  templateUrl: "./confirm-popup.component.html",
  styleUrls: ["./confirm-popup.component.scss"],
})
export class ConfirmPopupComponent extends ModalComponent implements OnInit {
  @Input() properties: any = {};
  @Input() title: string = "";
  @Input() message: string = "";
  @Input() buttonLabel = "Đồng ý";
  @Input() isConfirmButton: boolean = true;
  @Input() buttonCancelLabel = "Hủy";
  @Input() isCancelButton: boolean = true;
  @Input() func: any = null;
  @Input() cancelFunc: any = null;
  @Input() isDismissAll: boolean = false;
  @Input() subMessage: string = "";
  iconImage: any = "./assets/images/icons/ic-check.svg";
  @Output() result: EventEmitter<any> = new EventEmitter();
  Constant = Constant;

  config: any = {};
  constructor(
    private modalRef: NzModalRef,
    public eventManager: EventManager,
  ) {
    super(eventManager);
  }
  argree() {
    this.dismiss();
    if (this.func) {
      this.func();
    } else this.result.emit(true);
  }
  cancel() {
    this.dismiss();
    if (this.cancelFunc) {
      this.cancelFunc();
    } else this.result.emit(false);
  }
  dismiss() {
    this.modalRef.close();
  }
}
